export const setCurrentUser = (currentUser) => ({
  type: 'SET_CURRENT_USER',
  payload: currentUser
})

export const updateCalAnonymousId = (calAnonymousId) => ({
  type: 'UPDATE_CAL_ANONYMOUS_ID',
  payload: calAnonymousId
})
